<template>
  <section
    class="sidearm-mm-reaction text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100"
    data-anchor="reaction"
  >
    <section-background css_var="--section-desktop-bg-selection-sunday-reaction"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <div
      class="flex flex-align-center h-100 sidearm-mm-reaction__inner relative"
    >
      <div class="sidearm-mm-reaction__details col-3-of-8 col-push-1">
        <h2 v-if="section.title" class="type-hero mt-0 mb-4">
          {{ section.title }}
        </h2>

        <p v-if="section.sub_title" class="type-paragraph-large mt-0 mb-2">
          {{ section.sub_title }}
        </p>

        <div v-if="section.reaction_video" class="flex flex-align-center">
          <modal-video :video="section.reaction_video">
            <button
              slot-scope="scope"
              type="button"
              @click="scope.open"
              class="sidearm-mm-play-btn"
              aria-label="Play video: Team reaction to Selection Sunday"
            >
              <icon>sf-play-minimal</icon>
            </button>
          </modal-video>

          <div
            v-if="section.reaction_video_play_button_label"
            class="type-heading mx-2"
          >
            {{ section.reaction_video_play_button_label }}
          </div>
        </div>
      </div>

      <div class="sidearm-mm-reaction__divider col-1-of-8 relative">
        <span></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true }
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-reaction {
  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 62.5%;
  }

  &::before {
    border-radius: 50%;
    border: 1px solid $color-white;
    bottom: grid_percent(120);
    display: block;
    height: 1.5rem;
    transform: translateX(-50%);
    width: 1.5rem;
  }

  &::after {
    opacity:.5;
    background-color: $color-white;
    bottom: 0;
    height: grid_percent(120);
    width: 1px;
  }

  &__inner {
    padding-top: $header-height;
  }

  &__divider {
    > span {
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }

    &::before {
      border-bottom: 1px solid $color-white;
      border-right: 1px solid $color-white;
      bottom: 50%;
      content: "";
      display: block;
      height: 100vh;
      left: 1.5rem;
      position: absolute;
      width: calc(100% - 1.5rem);
    }
  }
  .sidearm-mm-play-btn {
    @include play-btn(6rem);
  }
}
</style>
